import { isNud } from '@/shared/utilities/typing';

/**
 * 観点別評価 エンティティ
 */
class DetailedRank {
    detailed_rank_id;
    year;
    grade;
    threshold;
    rank_label;

    constructor(properties) {
        if (isNud(properties)) {
            properties = {};
        }

        this.detailed_rank_id = properties.detailed_rank_id;
        this.year = properties.year;
        this.grade = properties.grade;
        this.threshold = properties.threshold;
        this.rank_label = properties.rank_label;
    }
}

export default DetailedRank;
